import styled from 'styled-components/macro';
import { fonts, colours, mediaQuery } from '@noths/styles-config';

export const Container = styled.form({
  padding: '20px 0',
  color: colours.mineShaft,
  width: '100%',
  alignSelf: 'center',
  [mediaQuery('tablet desktop')]: {
    maxWidth: '500px',
    padding: '32px',
    border: '1px solid #E7EBEC',
    borderRadius: '3px',
  },
});

export const Header = styled.h2({
  fontFamily: fonts.family.v2,
  fontWeight: 'bold',
  fontSize: fonts.size.l,
  letterSpacing: '1px',
  margin: 0,
  textAlign: 'center',
  [mediaQuery('tablet desktop')]: {
    paddingTop: '0px',
  },
});

export const InputContainer = styled.div`
  margin: 10px 0;
  width: 100%;
`;
